import React from 'react';

import styles from './Title.module.scss';

const Title = () => (<h3 className={styles.title}>Your report for TAURUS is ready</h3>);

export default Title;
